<template>
  <FormItem 
    :label="label"
    :label-width="labelWidth"
    :prop="prop"
  >
    <p
      v-if="tips"
      v-text="tips"
      class="fz-tiny"
    />
    <RadioGroup 
      v-model="val"
      size="large"
      :type="type" 
    >
      <Radio 
        v-for="radio in radios"
        :key="radio.label"
        :label="radio.label"
        :disabled="disabled==true"
      />
    </RadioGroup>
  </FormItem>
</template>

<script>
  import { FormItem, RadioGroup, Radio } from 'iview';

  export default {
    components: { FormItem, RadioGroup, Radio },
    props: {
      prop: {
        type: String,
        default: null
      },
      radios: {
        type: Array,
        default: null
      },
      value: {
        type: [String, Boolean],
        default: null
      },
      type: {
        type: String,
        default: null
      },
      tips: {
        type: String,
        default: null
      },
      label: {
        type: String,
        default: ''
      },
      labelWidth: {
        type: Number,
        default: null
      },
      desc: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      val: {
        get() {
          const { value, radios } = this;            
          const { label } = radios.find(radio => radio.value === value);
          return label;
        },
        set(val) {
          const { radios } = this;
          const { value } = radios.find(radio => radio.label === val);
          this.$emit('input', value);
        }
      }
    }
  };
</script>
